export default __webpack_public_path__ + "c0651c75f95f4ae94bc59ddd3ca64d45.png";